import { render } from "./ForBidden.vue?vue&type=template&id=3b9cdce3"
import script from "./ForBidden.vue?vue&type=script&lang=js"
export * from "./ForBidden.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__